import SelectComponent from './SelectComponent';

export default SelectComponent;
